module.exports = __webpack_public_path__ + "202222:4f4eb5d45eb7a9e97a70/img/heroMobile@1x.dd0c66c.png";